import * as React from 'react';
import { ReactComponent as NWLogoSVG } from '../assets/nw-logo--compact.svg';

export default function Logo({ className }: { className?: string }) {
  return (
    <div className={`w-[60px] ${className}`}>
      <NWLogoSVG />
    </div>
  );
}